<template>
  <div
    class="page_container goodsManageSet"
    v-loading="loading"
    element-loading-text="请稍后"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manageCenterIndex/userManagement' }">业务管理</el-breadcrumb-item>
        <el-breadcrumb-item>业务通知管理设置</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!--  主要内容 start -->
    <div class="form_container">
      <h1>业务通知管理设置</h1>
      <div class="content_wrap flex-between">
        <div class="form_wrap">
          <div class="block">
            <p><span class="mark">*</span>待审批的企业成员申请通知人</p>
            <!-- <div class="select_box">
              <el-select
                v-model="formData.mobile_user"
                placeholder="请选择待审批的企业成员申请通知人"
              >
                <el-option
                  v-for="item in userList"
                  :key="item.id"
                  :label="item.msg"
                  :value="item.msg"
                >
                </el-option>
              </el-select>
            </div> -->
            <!-- <div class="input_box">
              <el-input
                v-model="formData.mobile_user"
                placeholder="请填写待审批的企业成员申请通知人"
              />
            </div> -->
            <div
              class="select_customer flex-rowc"
              @click="handleShowUser('selectUser')"
            >
              请选择待审批的企业成员申请通知人
            </div>
            <div class="select_customer_wrap" v-if="formData.mobile_user">
              <p>
                员工姓名：<span>{{ selectUser.truename }}</span>
              </p>
              <p>
                部门：<span>{{ selectUser.deptname }}</span>
              </p>
              <p>
                角色：<span>{{ selectUser.rolename }}</span>
              </p>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>待审批的合作商家申请通知人</p>
            <!-- <div class="select_box">
              <el-select
                v-model="formData.mobile_cmuser"
                placeholder="请选择待审批的合作商家申请通知人"
              >
                <el-option
                  v-for="item in userList"
                  :key="item.id"
                  :label="item.msg"
                  :value="item.msg"
                >
                </el-option>
              </el-select>
            </div> -->
            <div
              class="select_customer flex-rowc"
              @click="handleShowUser('selectCmuser')"
            >
              请选择待审批的合作商家申请通知人
            </div>
            <div class="select_customer_wrap" v-if="formData.mobile_cmuser">
              <p>
                员工姓名：<span>{{ selectCmuser.truename }}</span>
              </p>
              <p>
                部门：<span>{{ selectCmuser.deptname }}</span>
              </p>
              <p>
                角色：<span>{{ selectCmuser.rolename }}</span>
              </p>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>待发货的订单通知人</p>
            <!-- <div class="select_box">
              <el-select
                v-model="formData.mobile_sendgoods"
                placeholder="请选择待发货的订单通知人"
              >
                <el-option
                  v-for="item in userList"
                  :key="item.id"
                  :label="item.msg"
                  :value="item.msg"
                >
                </el-option>
              </el-select>
            </div> -->
            <div
              class="select_customer flex-rowc"
              @click="handleShowUser('selectSendgoods')"
            >
              请选择待发货的订单通知人
            </div>
            <div class="select_customer_wrap" v-if="formData.mobile_sendgoods">
              <p>
                员工姓名：<span>{{ selectSendgoods.truename }}</span>
              </p>
              <p>
                部门：<span>{{ selectSendgoods.deptname }}</span>
              </p>
              <p>
                角色：<span>{{ selectSendgoods.rolename }}</span>
              </p>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>待审核的退款申请通知人</p>
            <!-- <div class="select_box">
              <el-select
                v-model="formData.mobile_checkreturn"
                placeholder="请选择待审核的退款申请通知人"
              >
                <el-option
                  v-for="item in userList"
                  :key="item.id"
                  :label="item.msg"
                  :value="item.msg"
                >
                </el-option>
              </el-select>
            </div> -->
            <div
              class="select_customer flex-rowc"
              @click="handleShowUser('selectCheckreturn')"
            >
              请选择待审核的退款申请通知人
            </div>
            <div
              class="select_customer_wrap"
              v-if="formData.mobile_checkreturn"
            >
              <p>
                员工姓名：<span>{{ selectCheckreturn.truename }}</span>
              </p>
              <p>
                部门：<span>{{ selectCheckreturn.deptname }}</span>
              </p>
              <p>
                角色：<span>{{ selectCheckreturn.rolename }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form_footer flex-rowl">
      <div class="btn" @click="query">保存</div>
      <div class="return_txt" @click="handleReturn">←返回</div>
    </div>
    <!--  主要内容 end -->

    <div class="custom_dialog" v-show="isShow">
      <div class="custom_wrap">
        <div class="diaog_head">
          <div class="close_icon" @click="isShow = false">
            <i class="iconfont icon-guanbi"></i>
          </div>
          <div class="search_box flex-between">
            <el-input
              v-model="customerParams.keyword"
              placeholder="输入员工姓名/ID/部门，查找后选择员工"
              @keyup.enter.native="getApplyCompanyList"
            ></el-input>
            <div class="search_btn flex-rowc" @click="getApplyCompanyList">
              <i class="iconfont icon-chazhaotubiao"></i>
            </div>
          </div>
        </div>
        <div class="diaog_body">
          <div class="radio_wrap">
            <div class="radio_group flex-rowl" v-if="qyUserList.length > 0">
              <div
                class="radio_item flex-rowl"
                v-for="item in qyUserList"
                :key="item.id"
                @click="handleUser(item.id)"
              >
                <i
                  class="iconfont"
                  :class="
                    selectQyId === item.id
                      ? 'icon-danxuanyixuan1'
                      : 'icon-quanxuan'
                  "
                ></i>
                <div class="radio_content">
                  <p>
                    员工姓名：<span>{{ item.user.truename }}</span>
                  </p>
                  <p>
                    部门：<span>{{ item.deptname }}</span>
                  </p>
                  <p>
                    角色：<span>{{ item.rolename }}</span>
                  </p>
                </div>
              </div>
            </div>
            <el-empty description="暂无成员" v-else></el-empty>
          </div>
        </div>
        <div class="dialog_footer flex-rowl">
          <div class="btn" @click="handleQueryQy">确认</div>
          <div class="return_txt" @click="isShow = false">←返回</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { encryptstringview } from "../../api/api";
import {
  editQyNotice,
  getQyNoticeDetail,
  getApplyCompanyList,
} from "../../api/company";
export default {
  name: "serviceNitoceManage",
  data() {
    return {
      loading: false,
      id: "",
      qyguid: "",
      formData: {
        mobile_user: "",
        mobile_cmuser: "",
        mobile_sendgoods: "",
        mobile_checkreturn: "",
      },

      qyid: "",

      isShow: false,
      qyUserList: [],
      selectQyId: "",
      selectQy: {}, // 选择的企业
      customerParams: {
        qyid: "",
        keyword: "",
        checkstate: 1, // 0审核中 1已通过 2拒绝加入 3已退出 4已被移出
      },
      selectUser: {}, // 待审批的企业成员申请通知人
      selectCmuser: {}, // 待审批的合作商家申请通知人
      selectSendgoods: {}, // 待发货的订单通知人
      selectCheckreturn: {}, // 待审核的退款申请通知人
      selectType: "selectUser",
    };
  },
  computed: {
    isDisabled() {
      return (item) => {
        // 根据某些条件来判断是否禁用某个选项
        if (this.pernumCheck.includes(item.areaid)) {
          return true;
        }
        return false;
      };
    },
    isDisabled1() {
      return (item) => {
        // 根据某些条件来判断是否禁用某个选项
        if (this.ruleCheck.includes(item.areaid)) {
          return true;
        }
        return false;
      };
    },
  },
  created() {
    let { routerList, OPENID, USERINFO } = this.$store.state;
    let { name } = this.$route;
    this.customerParams.qyid = USERINFO.qy.id ? USERINFO.qy.id : "";
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { qyguid, qyid, id } = JSON.parse(res.jsondata);
        this.qyguid = qyguid;
        this.id = id;
        this.qyid = qyid;

        this.getApplyCompanyList(false, "");
      } else {
        this.$router.back();
      }
    },

    handleShowUser(type) {
      this.getApplyCompanyList(true, type);
      this.selectType = type;
      this.isShow = true;
    },

    // 员工选择
    handleUser(id) {
      this.selectQyId = id;
    },
    // 选中员工
    handleQueryQy() {
      let { selectQyId, qyUserList, selectType } = this;
      if (selectQyId == "") {
        this.$message.warning("请选择员工");
      } else {
        qyUserList.forEach((v) => {
          if (v.id == selectQyId) {
            this[selectType].id = v.id;
            this[selectType].truename = v.user.truename;
            this[selectType].deptname = v.deptname;
            this[selectType].rolename = v.rolename;
            if(selectType == 'selectUser') {
              this.formData.mobile_user = v.user.truename + " | " + v.mobile
            }
            if(selectType == 'selectCmuser') {
              this.formData.mobile_cmuser = v.user.truename + " | " + v.mobile
            }
            if(selectType == 'selectSendgoods') {
              this.formData.mobile_sendgoods = v.user.truename + " | " + v.mobile
            }
            if(selectType == 'selectCheckreturn') {
              this.formData.mobile_checkreturn = v.user.truename + " | " + v.mobile
            }
          }
        });
        this.isShow = false;
      }
    },

    getApplyCompanyList(isClick, type) {
      getApplyCompanyList(this.customerParams).then((res) => {
        this.qyUserList = res;
        if (isClick && type != "") {
          res.forEach((v) => {
            if (v.id == this[type].id && this[type].id) {
              this.selectQy = v;
              this.selectQyId = this[type].id;
            }
          });
        } else {
          this.getQyNoticeDetail();
        }
      });
    },

    // 获取企业通知详情
    getQyNoticeDetail() {
      let { qyUserList } = this;
      this.loading = true;
      getQyNoticeDetail({ id: this.id }).then((res) => {
        this.formData.mobile_user = res.mobile_user ? res.mobile_user : "";
        let mobile_user = res.mobile_user
          ? res.mobile_user.split(" | ")[1]
          : "";
        this.formData.mobile_cmuser = res.mobile_cmuser
          ? res.mobile_cmuser
          : "";
        let mobile_cmuser = res.mobile_cmuser
          ? res.mobile_cmuser.split(" | ")[1]
          : "";
        this.formData.mobile_sendgoods = res.mobile_sendgoods
          ? res.mobile_sendgoods
          : "";
        let mobile_sendgoods = res.mobile_sendgoods
          ? res.mobile_sendgoods.split(" | ")[1]
          : "";
        this.formData.mobile_checkreturn = res.mobile_checkreturn
          ? res.mobile_checkreturn
          : "";
        let mobile_checkreturn = res.mobile_checkreturn
          ? res.mobile_checkreturn.split(" | ")[1]
          : "";
        qyUserList.forEach((v) => {
          if (v.mobile == mobile_user) {
            this.selectUser.id = v.id;
            this.selectUser.truename = v.user.truename;
            this.selectUser.deptname = v.deptname;
            this.selectUser.rolename = v.rolename;
          }
          if (v.mobile == mobile_cmuser) {
            this.selectCmuser.id = v.id;
            this.selectCmuser.truename = v.user.truename;
            this.selectCmuser.deptname = v.deptname;
            this.selectCmuser.rolename = v.rolename;
          }
          if (v.mobile == mobile_sendgoods) {
            this.selectSendgoods.id = v.id;
            this.selectSendgoods.truename = v.user.truename;
            this.selectSendgoods.deptname = v.deptname;
            this.selectSendgoods.rolename = v.rolename;
          }
          if (v.mobile == mobile_checkreturn) {
            this.selectCheckreturn.id = v.id;
            this.selectCheckreturn.truename = v.user.truename;
            this.selectCheckreturn.deptname = v.deptname;
            this.selectCheckreturn.rolename = v.rolename;
          }
        });
        this.loading = false;
      });
    },

    query() {
      let { formData, id, qyguid } = this;
      if (formData.mobile_user == "") {
        this.$message.warning("请选择待审批的企业成员申请通知人");
        return;
      }
      if (formData.mobile_cmuser == "") {
        this.$message.warning("请选择待审批的合作商家申请通知人");
        return;
      }
      if (formData.mobile_sendgoods == "") {
        this.$message.warning("请选择待发货的订单通知人");
        return;
      }
      if (formData.mobile_checkreturn == "") {
        this.$message.warning("请选择待审核的退款申请通知人");
        return;
      }
      this.formData.id = id;
      this.formData.qyguid = qyguid;
      this.loading = true;
      editQyNotice(formData).then((res) => {
        if (res.result) {
          setTimeout(() => {
            this.loading = false;
            this.$router.back();
          }, 500);
        } else {
          this.loading = false;
          this.$message.error(res.message || "服务器报错，请稍后～");
        }
      });
    },

    handleReturn() {
      history.back();
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  .form_container {
    .content_wrap {
      .form_wrap {
        margin-right: 100px;
      }
      .tip_wrap {
        flex: 1;
        .item {
          margin-bottom: 30px;
          color: #6e6e6e;
          h1 {
            margin-bottom: 8px;
            font-size: 18px;
          }
          p {
            font-size: 16px;
          }
        }
      }
      .select_customer {
        border: 1px solid #dcdfe6;
        background: #fff;
        height: 40px;
        cursor: pointer;
      }
      .select_customer_wrap {
        border: 1px solid #dcdfe6;
        background: #fff;
        margin-top: 20px;
        padding: 10px 20px;
        box-sizing: border-box;
        p {
          font-size: 14px;
        }
      }
    }
  }
  .custom_wrap {
    .diaog_body {
      h1 {
        font-size: 18px;
        color: #6e6e6e;
      }
      p {
        font-size: 14px;
        // color: #ff0012;
        margin: 15px 0 14px;
      }
      .radio_wrap {
        .radio_group {
          flex-wrap: wrap;
          .radio_item {
            flex-shrink: 0;
            width: 100%;
            border: 1px solid #dcdcdc;
            margin-right: 80px;
            font-size: 14px;
            color: #6e6e6e;
            margin-bottom: 20px;
            padding: 0 10px;
            box-sizing: border-box;
            cursor: pointer;
            .iconfont {
              font-size: 22px;
              margin-right: 10px;
              color: #a5a5a5;
              &.icon-danxuanyixuan1 {
                color: #f62560;
              }
            }
          }
        }
      }
    }
    .dialog_footer {
      .link {
        a {
          font-size: 16px;
          color: #f62560;
        }
      }
    }
  }
}
</style>